import {
  type CompatibleStorageValue,
  getLocalStorageStateDefaultOptions,
  useLocalStorageState as useLocalStorageStateFromCosunoUi,
  type UseLocalStorageStateOptions,
} from '@cosuno/cosuno-ui';

import { parseValue } from '../utils';

const otherDefaults = {
  parse: parseValue,
  stringify: JSON.stringify,
};

export default function useLocalStorageState<
  T extends CompatibleStorageValue,
  PersistedParsedValue extends CompatibleStorageValue = T,
>(
  storageKey: string,
  emptyValue: T,
  options: UseLocalStorageStateOptions<T, PersistedParsedValue> = {},
) {
  return useLocalStorageStateFromCosunoUi(storageKey, emptyValue, {
    ...getLocalStorageStateDefaultOptions<T, PersistedParsedValue>(),
    ...otherDefaults,
    ...options,
  });
}
